import type { Placement, Side } from '@floating-ui/dom';

/** Where an arrow sits on its floating element: which edge, and its left/top/right/bottom. */
export interface IArrowPosition {
  side: Side;
  style: { bottom: string; left: string; right: string; top: string };
}

const OPPOSITE: Record<Side, Side> = { bottom: 'top', left: 'right', right: 'left', top: 'bottom' };
const SIDES: Side[] = ['bottom', 'left', 'right', 'top'];

export function placementSide(placement: Placement): Side {
  return SIDES.find((side) => placement.startsWith(side)) ?? 'bottom';
}

/**
 * The arrow goes on the edge facing the reference, `outsetPx` past it, at floating-ui's x/y along that edge.
 * The side returned is the arrow's edge, so `right` placement gives a `left` arrow.
 */
export function arrowPosition(placement: Placement, outsetPx: number, x?: number, y?: number): IArrowPosition {
  const side = OPPOSITE[placementSide(placement)];
  const style = { bottom: '', left: x === undefined ? '' : `${x}px`, right: '', top: y === undefined ? '' : `${y}px` };
  return { side, style: { ...style, [side]: `${-outsetPx}px` } };
}
